import { render, staticRenderFns } from "./Adicionais.vue?vue&type=template&id=744b2200"
import script from "./Adicionais.vue?vue&type=script&lang=js"
export * from "./Adicionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports